import type { ValidationState } from 'Store/trip-information/kids/constants';
import { DEFAULT_KID_VALUE, VALIDATION_STATE_ENUM } from 'Store/trip-information/kids/constants';
import { isKidMinor } from 'Utils/faceting/facetingUtils';
import type { Kids } from 'Store/trip-information/kids/kids.reducer';
import 'Store/trip-information/kids/kids.reducer';
import {
  IS_INVALID,
  IS_VALID,
  NOT_VALIDATED,
} from 'Components/frameworks/form-validator-hoc/validationStates';
export const getValidationStateFromKid = (kid: Kids, isKidBirthdateRequired?: boolean) => {
  if (typeof kid !== 'object') {
    return IS_INVALID;
  }

  if (!kid.birthdate) {
    return isKidBirthdateRequired ? IS_INVALID : NOT_VALIDATED;
  }

  return typeof kid === 'object' && isKidMinor(kid.birthdate) ? IS_VALID : IS_INVALID;
};
export const getValidationStateFromKids = (kids: Array<Kids> = []): Array<ValidationState> => {
  return kids.map((kid) => getValidationStateFromKid(kid));
};
type UpdateValidationStateForKidArgsType = {
  index: number;
  kid: Kids;
  kidsValidationState: Array<ValidationState>;
};
export const updateValidationStateForKid = ({
  index,
  kid,
  kidsValidationState = [],
}: UpdateValidationStateForKidArgsType): Array<ValidationState> => {
  const validationState = getValidationStateFromKid(kid);
  return kidsValidationState.map((kidValidation, indexKid) => {
    const isNewKid = kidValidation === NOT_VALIDATED;
    const kidNeedsValidation = !!kid.birthdate || !isNewKid;
    return indexKid === index && kidNeedsValidation ? validationState : kidValidation;
  });
};
export const addOrRemoveKidFromValidationState = ({
  currentState = [],
  kidsNumber,
}: {
  currentState: Array<ValidationState>;
  kidsNumber: number;
}): Array<ValidationState> => {
  if (kidsNumber > currentState.length) {
    return [
      ...currentState,
      ...Array(kidsNumber - currentState.length).fill(VALIDATION_STATE_ENUM.notvalidated),
    ];
  }

  if (kidsNumber < currentState.length) {
    return [...currentState.slice(0, kidsNumber)];
  }

  return currentState;
};
export const addOrRemoveKidFromKidsList = (args: {
  kids: Array<Kids>;
  kidsNumber: number;
}): Array<Kids> => {
  const { kids = [], kidsNumber } = args;

  if (kidsNumber > kids.length) {
    return [...kids].concat(
      Array(kidsNumber - kids.length)
        .fill(DEFAULT_KID_VALUE)
        .map(() => DEFAULT_KID_VALUE),
    );
  }

  if (kidsNumber < kids.length) {
    return [...kids.slice(0, kidsNumber)];
  }

  return kids;
};
export const hasKidWithoutAValidBirthdate = (
  kidsValidationState: Array<ValidationState>,
): boolean => {
  return Boolean(kidsValidationState && kidsValidationState.find((kid) => kid === IS_INVALID));
};
export const hasOnlyValidKids = (kidsValidationState: Array<ValidationState>): boolean => {
  return kidsValidationState.every((kid) => kid === IS_VALID);
};
export const invalidateNotValidatedKids = (kidsValidationState: Array<ValidationState>) => {
  return kidsValidationState.reduce((acc, current) => {
    if (current === NOT_VALIDATED) {
      return [...acc, IS_INVALID];
    }

    return [...acc, current];
  }, []);
};
